import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(assets-explorer)/[mainCategory]/[category]/layout.tsx");
